import course1 from "../assets/images/health-management.avif";
import course2 from "../assets/images/medical-science1.avif";
import course3 from "../assets/images/ayurvedic0.avif";

const imgMap = {
  course1: course1,
  course2: course2,
  course3: course3,
};

export default imgMap;
